/**
 * © 2022 Boston Consulting Group
 * Gamma D
 * Pardeep
 * Created: 2022-09-29
 */

/**
 * Create typography for Material-UI global theme.
 */
const typography = {
  fontFamily: ['Poppins', 'sans-serif'].join(','),
  h1: {
    fontWeight: 700,
    fontSize: 32,
    lineHeight: '44px',
  },
  h2: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '36px',
  },
  h3: {
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '30px',
  },
  subtitle1: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: '28px',
  },
  subtitle2: {
    fontWeight: 400,
    fontSize: 24,
    lineHeight: '34px',
  },
  body1: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
  },
  component: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
  },
  largestRegular: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
  },
  largestMedium: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
  },
  largestBold: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
  },
  mediumRegular: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '21px',
  },
  mediumMedium: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '21px',
  },
  mediumBold: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '21px',
  },
  smallRegular: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
  },
  smallMedium: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
  },
  smallBold: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: '16px',
  },
  extraSmallRegular: {
    fontWeight: 400,
    fontSize: 10,
    lineHeight: '16px',
  },
  extraSmallMedium: {
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '16px',
  },
  extraSmallBold: {
    fontWeight: 700,
    fontSize: 10,
    lineHeight: '16px',
  },
  caption: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
  },
  caption1: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
  },
  caption2: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
  },
  subOptions: {
    fontWeight: 500,
    fontSize: 15,
    lineHeight: '22px',
  }

};

// Export theme.
export default typography;
